import S from './styles';

const Notification = ({ description }) => (
  <S.Notification>
    <S.Notification.Text>{description}</S.Notification.Text>
  </S.Notification>
);

export default Notification;
